import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteProducer = async (producerId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/producer/${producerId}`);
  return res.data;
};

export default deleteProducer;
